module.exports = __webpack_public_path__ + "static/media/d-lighterTutor-logo.356a0de5.jpg";